@if (!!widgetVisible && !!htmlView) {
    <!--Custom attribute css-injection-scope is applied to avoid injected styles to bleed inside other components.

        Widget container CSS class is added from the component, to control which class apply depending on the
        widget output mode.

        Widget source id is added as container id for PDF exporting algorithm (backend) to be able to find
        this container inside the document.-->

    <div [cssInjectionScope]="cssInjectionScopeId"
         [class]="widgetContainerClass"
         [id]="widgetSourceId">

        <div class="widget-html-topbar">

            @if (!!widgetTitle?.length) {
                <h2>{{ widgetTitle }}</h2>
            }

            @if (!!exportable && output === 'web') {
                <p-button [loading]="pdfExportingLoading | async" (onClick)="generatePdf()"
                          styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                          class="exporting-button" icon="pi pi-file-pdf" title="Export to PDF">
                </p-button>
            }
        </div>

        <div #htmlContainer [class]="htmlContentClass"></div>
    </div>
}